import React, { useState, useEffect } from "react";
import { getRecommend, getOrgInfo, getGoods, IOrgInfo,getMechanismSelectionList,getIsFollow,follow,unFollow } from "../../api";
import { formatImgUrl } from '../../utils/index'
import styles from "./OrgInfo.module.css";
import QRCode from 'qrcode.react';
import logo from './img/logo.jpeg'
import { BUSINESS_INFO, getApiTypeByGetItem, ASSET_TYPE, ASSET_TYPE_NAME } from '../../constant'
import Toast from '../../components/Toast'
import { type } from "ramda";
import { Dialog } from '@jdcfe/lrc';

interface OrgProps {
  venderId: Number;
  chuzhiNoticeTotalCount: number;
  onLoadComplete?: (info: IOrgInfo) => void
}

const followType = 3; // 3是关注店铺

const OrgInfo: React.FC<OrgProps> = props => {
  const { venderId, chuzhiNoticeTotalCount } = props;

  const [publishSource, setPublishSource] = useState('');
  const [shopName, setShopName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [recommendCnt, setRecommendCnt] = useState(0);
  const [mechanismSelectionItemCnt, setMechanismSelectionItemCnt] = useState(0);
  const [logoUrl, setLogoUrl] = useState('');
  const [logoUrlSquare, setLogoUrlSquare] = useState('');
  const [productCnt, setProductCnt] = useState(0);
  const [isFollow, setFollow] = useState(false);
  const [toastTxt, setToastTxt] = useState('');
  const [breadNavTitle, setBreadNavTitle] = useState('');
  const [license, setLicense] = useState({
    have: false,
    show: false,
    value:  "",
    logo: "",
    link: "",
    businessQualificationMaterialList: []
  });
  // 拍卖行商家的弹窗展示形式
  const [businessQualificationMaterialListModal, setBusinessQualificationMaterialListModal] = useState(false);
  // 拍卖行商家的经营资质图片弹窗
  const [businessQualificationMaterialImageListModal, setBusinessQualificationMaterialImageListModal] = useState(false);

  const defaultLogo = 'http://img10.360buyimg.com/imagetools/jfs/t1/138119/1/21787/10515/61a74928E9260792f/881c87e11cf44299.jpg'
  const pcDefaultLogo = 'https://m.360buyimg.com/img/jfs/t1/58131/38/18188/6270/62aae92cEd31a2284/b40f53ecf5edbdbf.png'

  const getOrgDetail = () => {
    let { onLoadComplete } = props;
    getIsFollowFunc()
    getOrgInfo(venderId).then(res => {
      const {
        publishSource, 
        shopName, 
        companyName, 
        companyAddress, 
        logoUrl, 
        logoUrlSquare,
        dynamicSuccess,
        dynamicValue,
        shopId,
        businessQualificationMaterialList,
        assetType
      } = res;  
      setPublishSource(publishSource)
      setShopName(shopName)
      setCompanyName(companyName)
      setCompanyAddress(companyAddress)
      setLogoUrl(logoUrl)
      setLogoUrlSquare(logoUrlSquare || (parseInt(publishSource)===BUSINESS_INFO.POCHAN.code?pcDefaultLogo:defaultLogo))
      onLoadComplete && onLoadComplete(res)
      getbreadNavTitle(publishSource, assetType)
      setLicense({
        have: dynamicSuccess && dynamicValue === "DEFALUT_VALUE_NULL",
        show: true,
        value: dynamicValue,
        logo: "https://img10.360buyimg.com/imagetools/jfs/t1/186090/6/37108/3930/64ec0460F6fad06a7/6444b3d2022d3eca.png",
        link: shopId ? `https://mall.jd.com/showLicence-${shopId}.html` : "",
        businessQualificationMaterialList: businessQualificationMaterialList || []
      })
    });
  }

  const getRecommendCnt = () => {
    const auctionTypeMap = {
      [BUSINESS_INFO.POCHAN.code]: 5,
      [BUSINESS_INFO.HAIGUANANDZF.code]: 2,
      [BUSINESS_INFO.ZICHAN.code]: 4,
    };
    let params: any = {
      page: 1,
      pageSize: 1,
      sortType: 1,
      venderIdList: [venderId],
      auctionType: auctionTypeMap[parseInt(publishSource)] || 4,
    };
    if(parseInt(publishSource)===BUSINESS_INFO.ZICHAN.code){
      params.shopDisplay=1 // 1 店铺页展示 0 店铺页不展示
    }
    getRecommend(params).then(res => {
      let { totalCount } = res
      setRecommendCnt(totalCount || 0);
    });
  }

  const getProductCnt = () => {
    let params: any = {
      page: 1,
      pageSize: 1,
      vendorId: venderId,
      apiType: 12
      // apiType: getApiTypeByGetItem(parseInt(publishSource))
    }
    getGoods(params).then(res => {
      let { totalItem } = res
      setProductCnt(totalItem || 0)
    })
  }

  const getMechanismSelectionItemCnt = () => {
    let params: any = {
      pageNo: 1,
      pageSize: 1,
      venderId
    }
    getMechanismSelectionList(params).then(res => {
      let { totalCount } = res
      setMechanismSelectionItemCnt(totalCount || 0)
    })
  }

  const getIsFollowFunc =()=> {
    getIsFollow({id:venderId,type:followType}).then((res:boolean)=>{
      setFollow(res)
    })
  }

  const followClickHandle=() =>{
    if(isFollow){
      unFollow({id:venderId,type:followType}).then((res:any)=>{
        const {data,status} = res
        if(status==401){
          window.location.href = `https://passport.jd.com/new/login.aspx?ReturnUrl=${window.location.href}`
        }else if(data){
          setFollow(false)
          setToastTxt("已取消关注")
        }else{
          setToastTxt("网络环境异常，请检查后重试哦！如需帮助，请联系京东资产交易客服400-622-9586")
        }
      })
    }else{
      follow({id:venderId,type:followType}).then((res:any)=>{
        const {data,status} = res
        if(status==401){  //未登录
          window.location.href = `https://passport.jd.com/new/login.aspx?ReturnUrl=${window.location.href}`
        }else{
          if(data){
            setFollow(true)
            setToastTxt("关注成功")
          }else{
            setToastTxt("网络环境异常，请检查后重试哦！如需帮助，请联系京东资产交易客服400-622-9586")
          }
        }
      })
    }
  }

  //清空toast提示信息
  const clearToastTxt = () => {
    setToastTxt("")
  }

  const getbreadNavTitle=(publishSource:any, assetType: number)=>{
    let breadNavTitle = ""
    if(parseInt(publishSource)===BUSINESS_INFO.ZICHAN.code){

      breadNavTitle= ASSET_TYPE_NAME[assetType] || "金融资产"
    }else if(parseInt(publishSource)===BUSINESS_INFO.POCHAN.code){
      breadNavTitle="破产重整与清算"
    }else if(ASSET_TYPE_NAME[assetType]){
      breadNavTitle = ASSET_TYPE_NAME[assetType]
    }
    setBreadNavTitle(breadNavTitle)
  }

  useEffect(() => {
    getOrgDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [venderId]);

  useEffect(() => {
    getRecommendCnt()
    getProductCnt()
    getMechanismSelectionItemCnt()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [venderId, publishSource]);

  const handleBusinessQualificationMaterialListModal = (value: boolean) => {
    setBusinessQualificationMaterialListModal(value)
  }
  const handleBusinessQualificationMaterialImageListModal = (value: boolean) => {
    setBusinessQualificationMaterialListModal(false)
    setBusinessQualificationMaterialImageListModal(value)
  }

  return (
    <div className={styles.container}>
      <p className={styles.breadNav}>
        {breadNavTitle} &gt; {shopName}
      </p>
      <div className={styles.info}>
        <div className={styles.infoLeft}>
          {logoUrl ? (
            <img
              src={formatImgUrl(logoUrl)}
              className={styles.logo120}
              alt=""
            />
          ) : logoUrlSquare ? (
            <img
              src={formatImgUrl(logoUrlSquare)}
              className={styles.logo60}
              alt=""
            />
          ) : null}
        </div>
        <div className={styles.infoMiddle}>
          <div className={styles.infoMiddleWrap}>
            <p
              className={[
                styles.name,
                parseInt(publishSource) !== BUSINESS_INFO.ZICHAN.code
                  ? styles.noAddr
                  : "",
              ].join(" ")}
            >
              {shopName}
            </p>
            <div
              className={[
                styles.followBtn,
                isFollow ? styles.followed : "",
              ].join(" ")}
              onClick={() => {
                followClickHandle();
              }}
            >
              {isFollow === true ? "已关注" : "关注"}
            </div>
          </div>
          {
            <>
              <div className={styles.desc}>
                公司名称：{companyName}
                {/* 拍卖行的商家的展示形式 */}
                {license &&
                  license.have &&
                  license.show &&
                  license.link &&
                  license.businessQualificationMaterialList &&
                  license.businessQualificationMaterialList.length > 0 && (
                    <div
                      onClick={() =>
                        handleBusinessQualificationMaterialListModal(true)
                      }
                    >
                      <img
                        className={styles.licenseIcon}
                        src={license.logo}
                        alt=""
                      />
                    </div>
                  )}
                {/* 其他机构类型商家的展示形式 */}
                {license.have &&
                  license.show &&
                  license.link &&
                  !(
                    license.businessQualificationMaterialList &&
                    license.businessQualificationMaterialList.length > 0
                  ) && (
                    <a
                      className={styles.licenseLink}
                      href={license.link}
                      target="_blank"
                    >
                      <img
                        className={styles.licenseIcon}
                        src={license.logo}
                        alt=""
                      />
                    </a>
                  )}
                {
                  // 如果接口没返回shopId只展示图标无转跳链接
                  license.have &&
                    license.show &&
                    !license.link &&
                    !(
                      license.businessQualificationMaterialList &&
                      license.businessQualificationMaterialList.length > 0
                    ) && (
                      <img
                        className={styles.licenseIcon}
                        src={license.logo}
                        alt=""
                      />
                    )
                }
              </div>
              {companyAddress && (
                <p className={styles.desc}>所在地：{companyAddress}</p>
              )}
            </>
          }
        </div>
        <div className={styles.infoRight}>
          <p>
            <span className={styles.rightNumber}>{productCnt}</span>
            <br />
            标的物
          </p>
          {[
            BUSINESS_INFO.ZICHAN.code,
            BUSINESS_INFO.HAIGUANANDZF.code,
          ].includes(parseInt(publishSource)) && (
            <React.Fragment>
              <p>
                <span className={styles.rightNumber}>{recommendCnt}</span>
                <br />
                推介
              </p>
              {chuzhiNoticeTotalCount > 0 && (
                <p>
                  <span className={styles.rightNumber}>
                    {chuzhiNoticeTotalCount}
                  </span>
                  <br />
                  处置公告
                </p>
              )}
            </React.Fragment>
          )}
          {parseInt(publishSource) === BUSINESS_INFO.POCHAN.code && (
            <React.Fragment>
              <p>
                <span className={styles.rightNumber}>{recommendCnt}</span>
                <br />
                投资人招募
              </p>
              <p>
                <span className={styles.rightNumber}>
                  {mechanismSelectionItemCnt}
                </span>
                <br />
                机构选聘
              </p>
            </React.Fragment>
          )}
        </div>
      </div>

      <div className={styles.qrcodeContainer}>
        <div className={styles.qrcode}>
          <QRCode
            value={`https://pmmall.m.jd.com/#/mall/${venderId}?scan=1`}
            size={78}
            imageSettings={{
              src: logo,
              height: 10,
              width: 10,
              excavate: true,
            }}
          />
        </div>
        <div className={styles.qrcodeTxt}>扫一扫</div>
        <div className={styles.qrcodeTxt}>手机浏览信息</div>
      </div>
      {toastTxt && <Toast toastTxt={toastTxt} onHide={clearToastTxt}></Toast>}
      <Dialog
        hasMask={true}
        isOpen={businessQualificationMaterialListModal}
        lockScroll={true}
        onClose={() => handleBusinessQualificationMaterialListModal(false)}
        closeButton="x"
        title="商家资质查询"
      >
        <div className={styles.businessQualificationMaterialListModal}>
          <div>
            <span>营业执照：</span>
            <a
              className={styles.licenseLink}
              href={license.link}
              target="_blank"
              onClick={() =>
                handleBusinessQualificationMaterialListModal(false)
              }
            >
              查看
            </a>
          </div>
          <div>
            <span>拍卖经营资质：</span>
            <div
              className={styles.licenseLink}
              onClick={() =>
                handleBusinessQualificationMaterialImageListModal(true)
              }
            >
              查看
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        hasMask={true}
        isOpen={businessQualificationMaterialImageListModal}
        lockScroll={true}
        onClose={() => handleBusinessQualificationMaterialImageListModal(false)}
        closeButton="x"
        title="拍卖经营资质"
      >
        <div className={styles.businessQualificationMaterialImageListModal}>
          {license.businessQualificationMaterialList &&
            license.businessQualificationMaterialList.length > 0 &&
            license.businessQualificationMaterialList.map((item: string) => (
              <a target="_blank" rel="noopener noreferrer" href={item}>
                <img
                  className={styles.businessQualificationMaterialImg}
                  src={item}
                  alt=""
                />
              </a>
            ))}
        </div>
      </Dialog>
    </div>
  );
};

export default OrgInfo;
